import { Login } from 'react-admin';

const CustomLoginPage = () => (
    <Login 
        // A random image that changes everyday
        backgroundImage="https://images.unsplash.com/photo-1633545491399-54a16aa6a871?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1172&q=80"
    />
);

export {CustomLoginPage}